import React, { useContext, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { SignUp } from "../../services/auth/SignUp";
import { DContext } from "../../context/Datacontext";
import Loading from "../../components/Loading";

export const UserVerification = () => {
    const { BeURL , currentUser , loading ,setLoading} = useContext(DContext)
    const { state } = useLocation(); // { email, contact } from register
    const [otp, setOtp] = useState(["", "", "", "", "", ""]);
    const inputsRef = useRef([]);
    const [timer, setTimer] = useState(30);
    const [error, setError] = useState("");
    const [navigation,setNavigation] =useState(false)

    useEffect(() => {
      if(navigation){
         if(currentUser?.role === "user"){
             window.location.href = "/learner/courses"
         }
         else{
            window.location.href= "/app/dashboard"
         }
      }
    }, [navigation, currentUser])

    useEffect(() => {
        inputsRef.current[0]?.focus();
    }, []);

    // countdown
    useEffect(() => {
        if (timer <= 0) return;
        const id = setInterval(() => setTimer((t) => t - 1), 1000);
        return () => clearInterval(id);
    }, [timer]);

    const onChange = (index, value) => {
        if (!/^\d*$/.test(value)) return; // allow only digits
        const next = [...otp];
        next[index] = value.slice(-1);
        setOtp(next);

        if (value && index < 5) {
            inputsRef.current[index + 1]?.focus();
        }
    };

    const onKeyDown = (e, index) => {
        if (e.key === "Backspace" && !otp[index] && index > 0) {
            inputsRef.current[index - 1]?.focus();
        }
        if (e.key === "ArrowLeft" && index > 0) inputsRef.current[index - 1]?.focus();
        if (e.key === "ArrowRight" && index < 5) inputsRef.current[index + 1]?.focus();
    };

    const handlePaste = (e) => {
        const pasted = (e.clipboardData || window.clipboardData).getData("text");
        if (!/^\d{6}$/.test(pasted)) return;
        setOtp(pasted.split(""));
    };

    const handleVerify = async () => {
        setError("");

        const code = otp.join("");
        if (code.length !== 6) {
            setError("Enter 6 digit OTP");
            return;
        }
        setLoading(true);
        try {
            const res = await SignUp({
                BeURL,
                email: state?.form?.email,
                contact: state?.form?.contact,
                fullName: state?.form?.fullname,
                password: state?.form?.password,
                otp: code,
                role: state?.role,
                state 
            });
            if (res.success) {
                setError(res.message)
                setNavigation(true)
            } else {
                setError(res.message);
                setNavigation(false)
            }
        } catch (err) {
            console.log("Error on Otp verification failed", err)
            alert("Unable to Otp verification failed. Please try again later.");
            setError("OTP verification failed");
        } finally {
            setLoading(false);
        }
    };


    const handleResend = async () => {
        // TODO: call resend API
        // await api.post('/auth/resend-otp', { email: state?.email });
        setTimer(30);
    };

    return (
        <div className="min-h-screen flex items-center justify-center px-4">
            <div className="w-full max-w-md p-6 text-center">
                <h2 className="text-2xl font-semibold mb-2">OTP Verification</h2>
                <p className="text-sm text-gray-500 mb-6">
                    Enter the 6-digit code sent to <b className="text-primary-100">{state?.form?.email || state?.form?.contact || "your number/email"}</b>
                </p>

                <div
                    className="flex gap-2 justify-center mb-4"
                    onPaste={handlePaste}
                >
                    {otp.map((val, idx) => (
                        <input
                            key={idx}
                            ref={(el) => (inputsRef.current[idx] = el)}
                            value={val}
                            onChange={(e) => onChange(idx, e.target.value)}
                            onKeyDown={(e) => onKeyDown(e, idx)}
                            maxLength={1}
                            className="w-12 h-12 text-center border rounded-md text-lg focus:ring-2 focus:ring-blue-500"
                            inputMode="numeric"
                            pattern="[0-9]*"
                        />
                    ))}
                </div>

                {error && <p className="text-xs text-red-500 mb-3">{error}</p>}

                <button
                    onClick={handleVerify}
                    disabled={loading}
                    className="w-full bg-primary-600 flex justify-center text-white py-3 rounded-md mb-3 transition"
                >
                   {loading ? <Loading size={30} className="text-white" /> : "Verify OTP"}
                </button>

                {timer > 0 ? (
                    <p className="text-sm text-gray-500">Resend OTP in <b>{timer}</b> sec</p>
                ) : (
                    <button onClick={handleResend} className="text-primary-600 text-sm">
                        Resend OTP
                    </button>
                )}
            </div>
        </div>
    );
};
